import { render, staticRenderFns } from "./BesoinAide.vue?vue&type=template&id=81a790f6&"
import script from "./BesoinAide.vue?vue&type=script&lang=js&"
export * from "./BesoinAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports